import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { PlacementSummary } from '../services/api'

dayjs.extend(utc)
dayjs.extend(timezone)

const PACIFIC_TIMEZONE = 'America/Los_Angeles'

export const getPlacementStatus = (p: PlacementSummary): { label: string; variant: 'success' | 'primary' | 'neutral' } => {
  if (!p.is_active) return { label: 'Inactive', variant: 'neutral' }
  const now = dayjs().tz(PACIFIC_TIMEZONE)
  if (p.starts_at && dayjs(p.starts_at).tz(PACIFIC_TIMEZONE).isAfter(now)) return { label: 'Scheduled', variant: 'primary' }
  if (p.ends_at && dayjs(p.ends_at).tz(PACIFIC_TIMEZONE).isBefore(now)) return { label: 'Expired', variant: 'neutral' }
  return { label: 'Live', variant: 'success' }
}

export const formatCompactDate = (date: Date): string => {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: PACIFIC_TIMEZONE })
    + ' ' + date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: PACIFIC_TIMEZONE })
}

export const getScheduleDisplay = (p: PlacementSummary): string => {
  if (!p.starts_at && !p.ends_at) return 'Always'
  if (p.starts_at && p.ends_at) return `${formatCompactDate(p.starts_at)} – ${formatCompactDate(p.ends_at)}`
  if (p.starts_at) return `From ${formatCompactDate(p.starts_at)}`
  return `Until ${formatCompactDate(p.ends_at!)}`
}
